<template>
  <div>
    <!-- Перевод частичный -->
    <VCard class="calculator">
      <VRow>
        <VCol cols="12" md="4">
          <div class="calculator__title mb-6">
            {{ $t('interviewsMonthly') }}
          </div>
          <VTextField
            v-model="slider"
            class="mt-0 pt-0 huntica-hide-appearance"
            hide-details
            single-line
            filled
            type="number"
          />
          <div class="mx-n2 mt-n4">
            <VSlider
              v-model="slider"
              max="200"
              min="20"
              class="mx-0"
              hide-details
              dense
            />
          </div>
        </VCol>
        <VCol cols="12" md="4" lg="3">
          <div class="calculator__title mb-3 mb-md-5">
            {{ $t('tariffTerms') }}
          </div>
          <VRadioGroup v-model="radioGroup" hide-details>
            <VRadio
              :label="$t('creditCard')"
              value="card"
              color="success"
            />
            <VRadio
              :label="$t('onAccount')"
              value="account"
              color="success"
            />
          </VRadioGroup>
        </VCol>
        <VCol cols="12" md="4" lg="5" class="pt-0 pt-md-3">
          <div class="pt-md-11">
            <VCheckbox
              color="success"
              :label="$t('candidateNotification')"
              hide-details
              class="mb-1"
            />
            <VCheckbox
              color="success"
              :label="$t('autoInformer')"
              hide-details
              class="mb-1"
            />
            <VCheckbox
              color="success"
              :label="$t('offlineInterviewRecord')"
              hide-details
              class="mb-1"
            />
          </div>
        </VCol>
      </VRow>
      <VDivider class="mt-9 mb-3 d-none d-md-block" />
      <VRow>
        <VCol cols="12" md="4">
          <div class="display-2 primary__text mb-5">
            {{ $t('recommended') }}
            <div class="font-weight-bold">
              «Малый бизнес»
            </div>
          </div>
          <div class="mb-5">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequuntur corporis culpa
            dolore doloremque est impedit iusto laborum magni nam perferendis, placeat, quos sequi
            temporibus? Dignissimos laborum non rem sapiente sed!
          </div>
          <div class="text-center text-md-left">
            <VBtn>Выбрать тариф</VBtn>
          </div>
        </VCol>
        <VCol cols="12" md="8" class="px-0 pl-md-4 d-flex flex-column-reverse d-md-block">
          <VRow no-gutters class="prices" wrap>
            <VCol cols="9" md="4" class="prices__names">
              <div class="prices__row">
                Стоимость в месяц
              </div>
              <div class="prices__row">
                Пакет откликов
              </div>
              <div class="prices__row">
                Отклик сверх пакета
              </div>
              <div class="prices__row">
                Неограниченное количество вакансий
              </div>
            </VCol>
            <VCol cols="3" md="2" class="prices__item">
              <div class="prices__row">
                7 500&#8381;
              </div>
              <div class="prices__row">
                30
              </div>
              <div class="prices__row">
                0&#8381;
              </div>
              <div class="prices__row">
                <VIcon color="success">
                  {{ iconCheck }}
                </VIcon>
              </div>
            </VCol>

            <VCol cols="9" md="4" class="prices__names">
              <div class="prices__row">
                Запись видеоинтервью онлайн
              </div>
              <div class="prices__row">
                Запись очного интервью
              </div>
              <div class="prices__row">
                Оплата банковской картой
              </div>
              <div class="prices__row">
                Оплата по безналу
              </div>
            </VCol>

            <VCol cols="3" md="2" class="prices__item">
              <div class="prices__row">
                <VIcon color="success">
                  {{ iconCheck }}
                </VIcon>
              </div>
              <div class="prices__row">
                <VIcon color="success">
                  {{ iconCheck }}
                </VIcon>
              </div>
              <div class="prices__row">
                <VIcon color="success">
                  {{ iconCheck }}
                </VIcon>
              </div>
              <div class="prices__row">
                <VIcon color="success">
                  {{ iconCheck }}
                </VIcon>
              </div>
            </VCol>
          </VRow>
          <VDivider class="d-none d-md-block my-6" />
          <VRow align="end">
            <VCol cols="12" md="6" class="px-6 px-md-3">
              <div class="calculator__title mb-5">
                Единоразовый платеж за период
              </div>
              <VBtn
                v-for="btn in periods"
                :key="'btn'+btn"
                color="primary"
                small
                outlined
                class="period-btn"
                :class="{ 'active' : oneTimePayment === btn }"
                @click="oneTimePayment = btn"
              >
                {{ btn }}
              </VBtn>
            </VCol>
            <VCol cols="12" md="6" class="px-6 px-md-3 mb-4 mb-md-0">
              <div class="font-weight-medium pb-2">
                Средняя стоимость отклика:
                <span class="red--text font-weight-bold">250 рублей</span>
              </div>
              <div class="font-weight-medium pb-2">
                Будет начислено бонусных баллов:
                <span class="red--text font-weight-bold">1500</span>
              </div>
            </VCol>
          </VRow>
        </VCol>
      </VRow>
    </VCard>
    <div class="mt-1 mt-md-12 text-center text-md-left">
      <span class="calculator__title font-weight-light">Вы можете попробовать</span>
      <span class="calculator__title">
        промо тариф
        <span class="calculator__title font-weight-light">бесплатно</span>
      </span>
      <div class="d-md-none" />
      <VBtn class="ml-md-4 mt-3 mt-md-0">
        Попробовать
      </VBtn>
    </div>
  </div>
</template>

<script>
import { mdiCheck } from '@mdi/js';

export default {
  name: 'Calculator',
  data() {
    return {
      iconCheck: mdiCheck,
      radioGroup: 'card',
      slider: 100,
      oneTimePayment: 3,
      periods: [1, 3, 6, 9, 12],
    };
  },
};
</script>
<style lang="scss">
  .huntica-hide-appearance input[type="number"] {
    -moz-appearance: textfield;
    &:hover, &:focus {
      -moz-appearance: textfield;
    }
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
</style>
<style scoped lang="scss">
  .calculator {
    .v-input--radio-group .v-radio,
    .v-input--checkbox .v-input__slot {
      align-items: flex-start
    }
    &__title {
      font-size: 18px;
      font-weight: 500;
    }
  }
.prices {
  color: #000;
  margin: $spacer * 4 * -1;
  &__row {
    height: 64px;
    display: flex;
    align-items: center;
    &:nth-child(odd):not(.prices__row-action) {
      background: #EEF5FF;
    }
  }
  &__names {
    .prices__row {
      padding: 0 $spacer 0 $spacer * 3;
      text-align: left;
      line-height: 1.15;
    }
  }
  &__item {
    text-align: center;
    .prices__row {
      justify-content: center;
      font-weight: 500;
    }
  }
}

.v-btn.v-size--small.period-btn {
  min-width: 30px;
  padding: 0 $spacer;
  margin-right: $spacer * 2;
  font-weight: 300;
  &:not(.active) {
    border-color: transparent;
  }
  &.active {
    color: #333 !important;
    border-color: #333;
  }
}
@media #{map-get($display-breakpoints, 'xs-only')} {
  .title {
    font-size: 16px !important;
    line-height: 1.2;
  }
  .prices {
    font-size: 14px;
  }
}
@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .calculator {
    background: transparent;
    box-shadow: none;
  }
  .display-2 {
    font-size: 1.375rem !important;
    line-height: 1.3;
  }
}
@media #{map-get($display-breakpoints, 'md-and-up')} {
  .calculator {
    padding: $spacer * 5;
  }
  .prices {
    margin: 0;
    &__row {
      height: 70px;
    }
  }
}
@media #{map-get($display-breakpoints, 'lg-and-up')} {
  .prices{
    &__names {
      .prices__row {
        padding: 0 $spacer 0 $spacer * 5;
      }
    }
  }
}
</style>

<i18n locale="en" lang="yaml">
  interviewsMonthly: Interviews per month
  tariffTerms: Rates
  creditCard: Pay with a credit card
  onAccount: Pay with a bank account
  candidateNotification: Candidate notification
  autoInformer: Notifications by automated calls
  offlineInterviewRecord: Record in-person interviews
  recommended: Recommended rates
</i18n>

<i18n locale="ru" lang="yaml">
  interviewsMonthly: Собеседований в месяц
  tariffTerms: Выберите условия
  creditCard: Оплатить банковской картой
  onAccount: Оплатить по счету
  candidateNotification: Возможность оповестить кандидата
  autoInformer: Возможность оповещения через автоинформатор
  offlineInterviewRecord: Возможность записи оффлайн интервью
  recommended: Рекомендуемый тариф
</i18n>
